import AuditCommisionDetail from '../../components/Franchise/AuditCommisionDetail';

export default function AuditCommisionDetailPage() {
	return <AuditCommisionDetail />;
}
